module.exports = __webpack_public_path__ + "static/media/img-app-feature-2@3x.89567569.png";